<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import "./assets/css/app.scss"; //Tailwind CSS

export default {
  name: "app",

  methods: {
    offlineStatus() {
      this.$toasted.error("Ops... parece que você está offline...", {});
    },
    onlineStatus() {
      this.$toasted.success("Maravilha! Você está online novamente!", {
        icon: "done_outline"
      });
    },
    installEvent(e) {
      // Stash the event so it can be triggered later.

      let deferredPrompt = e;

      this.$toasted.info("Instale com um Clique!", {
        position: "top-center",
        fitToScreen: true,
        className: "toast-install",
        duration: 5000,
        icon: "mobile_screen_share",
        action: [
          {
            text: "Instalar",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);

              deferredPrompt.prompt();
              // Wait for the user to respond to the prompt
              deferredPrompt.userChoice.then(choiceResult => {
                if (choiceResult.outcome === "accepted") {
                  // console.log("User accepted the A2HS prompt");
                } else {
                  // console.log("User dismissed the A2HS prompt");
                }
                deferredPrompt = null;
              });
            }
          },
          {
            text: "Cancelar",
            // router navigation
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        ]
      });
    }
  },

  created() {
    window.addEventListener("online", this.onlineStatus);
    window.addEventListener("offline", this.offlineStatus);

    window.addEventListener("beforeinstallprompt", this.installEvent);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  }
};
</script>
